
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/[...slug]",
      function () {
        return require("private-next-pages/whatsapp-integrations/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/[...slug]"])
      });
    }
  